<template>
    <v-snackbar
        v-if="notification"
        v-model="isShown"
        bottom
        :color="notification.color"
        :timeout="notification.timeout"
    >
        {{ notification.text || null }}
        <v-btn
            v-if="notification.action"
            color="secondary"
            text
            @click="notification.action.click()"
        >
            {{ notification.action.text }}
        </v-btn>
    </v-snackbar>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'Snackbar',

        data: () => ({
            notification: undefined,
            isShown: false,
            timeout: 5000,
        }),

        computed: {
            ...mapGetters({
                notifications: 'notification/getLowNotifications',
            }),
        },

        watch: {
            notifications: {
                handler: function (notifications) {
                    if (notifications.length) {
                        this.showNotifications()
                    }
                },
                immediate: true,
            },

            isShown(isShown) {
                if (!isShown) {
                    if (this.notification) {
                        this.$store.dispatch('notification/delete', this.notification.id)
                    }
                }
            },
        },

        methods: {
            showNotifications() {
                if (!this.showNotificationsInterval) {
                    if (this.notifications.length) {
                        this.setNotification(this.notifications[0] || null)

                        this.showNotificationsInterval = window.setInterval(() => {
                            if (this.notifications.length) {
                                this.setNotification(this.notifications[0] || null)
                            } else {
                                window.clearInterval(this.showNotificationsInterval)
                                this.showNotificationsInterval = undefined
                                this.notification = undefined
                            }
                        }, this.timeout + 500)
                    }
                }
            },

            setNotification(payload) {
                const id = payload.id || null
                const text = payload.text || null
                const color = payload.color || null
                const action = payload.action || null
                const timeout = payload.timeout || this.timeout

                if (text && id) {
                    this.notification = {
                        id,
                        text,
                        color,
                        action,
                        timeout,
                    }

                    this.isShown = true
                }
            },
        },
    }
</script>
